import { Radio, RadioGroup, SimpleGrid, Stack } from "@chakra-ui/react";
import { useState } from "react";

export default function RadioInputs() {
  const [selectedNumber, setSelectedNumber] = useState("");

  const handleSelectNumber = (value) => {
    setSelectedNumber(value);
  };

  const options = [
    "3D",
    "Minimalist",
    "Watercolor",
    "Geometric",
    "Modern",
    "Hand-drown",
    "Vintage",
    "Signature",
    "Lettering",
    "Cartoon",
    "Other",
  ];

  return (
    <RadioGroup onChange={handleSelectNumber} value={selectedNumber}>
      <SimpleGrid
        columns={{ base: 1, sm: 2, lg: 3, xl: 4, "2xl": 5 }}
        gap={5}
        p={2}
        fontSize={{ lg: "14px" }}
      >
        {options.map((option) => (
          <Radio key={option} value={option}>
            {option}
          </Radio>
        ))}
      </SimpleGrid>
      <Stack direction="row"></Stack>
    </RadioGroup>
  );
}
